(() => {
  // SN2 — Live suggestions for the collection-page search bar.
  // Fetches Shopify's own suggest API while typing and shows a dropdown.
  // Normalizes compound product queries (e.g. "zip up" -> "title:zipup") so
  // out-of-stock exact matches are never buried under unrelated partial matches.
  const MIN_CHARS = 2;
  const DEBOUNCE_MS = 250;
  const LIMIT = 6;

  function normalizeSearchQuery(value) {
    if (typeof window !== 'undefined' && typeof window.__sn2NormalizeSearchQuery === 'function' && window.__sn2NormalizeSearchQuery !== normalizeSearchQuery) {
      return window.__sn2NormalizeSearchQuery(value);
    }
    if (!value || typeof value !== 'string') return value;
    return value.trim();
  }

  function viewAllUrl(form, q) {
    const type = form.querySelector('input[name="type"]');
    const normalized = normalizeSearchQuery(q);
    return (
      form.getAttribute('action') +
      '?type=' +
      encodeURIComponent(type ? type.value : 'product') +
      '&options%5Bprefix%5D=last&q=' +
      encodeURIComponent(normalized)
    );
  }

  function buildPanel(form) {
    const panel = document.createElement('div');
    panel.className = 'sn2-search-drop bg-page text-body border border-body';
    panel.setAttribute('role', 'listbox');
    panel.hidden = true;
    form.parentElement.appendChild(panel);
    return panel;
  }

  function row(product) {
    const a = document.createElement('a');
    a.className = 'sn2-search-row flex items-center gap-3 px-4 py-3 border-t border-body bg-page text-body';
    a.setAttribute('role', 'option');
    a.href = product.url || '#';
    if (product.image) {
      const img = document.createElement('img');
      img.src = product.image;
      img.alt = '';
      img.loading = 'lazy';
      img.width = 44;
      img.height = 44;
      img.className = 'sn2-search-thumb';
      a.appendChild(img);
    }
    const span = document.createElement('span');
    span.textContent = product.title || '';
    a.appendChild(span);
    return a;
  }

  function footerLink(form, q) {
    const a = document.createElement('a');
    a.className = 'sn2-search-row flex items-center justify-center px-4 py-3 border-t border-body bg-page text-body font-heading heading-case';
    a.href = viewAllUrl(form, q);
    a.textContent = 'View all results';
    return a;
  }

  function emptyRow(q) {
    const div = document.createElement('div');
    div.className = 'sn2-search-row px-4 py-3 border-t border-body bg-page text-body';
    div.textContent = `No products found for "${q}" — press Enter to search anyway.`;
    return div;
  }

  function wire(scope) {
    const form = scope.querySelector('form');
    const input = scope.querySelector('input[name="q"]');
    if (!form || !input) return;
    const panel = buildPanel(form);
    let controller = null;
    let timer = null;
    let active = -1;

    function hide() {
      panel.hidden = true;
      panel.innerHTML = '';
      active = -1;
      input.setAttribute('aria-expanded', 'false');
    }

    function show(q, products) {
      panel.innerHTML = '';
      if (products.length) {
        products.forEach((p) => panel.appendChild(row(p)));
        panel.appendChild(footerLink(form, q));
      } else {
        panel.appendChild(emptyRow(q));
      }
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function search(q) {
      if (controller) controller.abort();
      controller = new AbortController();
      const normalized = normalizeSearchQuery(q);
      const url =
        '/search/suggest.json?q=' +
        encodeURIComponent(normalized) +
        '&resources[type]=product&resources[options][prefix]=last&resources[options][fields]=title&resources[limit]=' +
        LIMIT;
      fetch(url, { signal: controller.signal })
        .then((r) => (r.ok ? r.json() : null))
        .then((d) => {
          if (!d) return;
          const products = ((d.resources || {}).results || {}).products || [];
          // Only render if the input still holds this query.
          if (input.value.trim() !== q) return;
          show(q, products);
        })
        .catch(() => {});
    }

    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', '');
    input.setAttribute('autocomplete', 'off');

    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < MIN_CHARS) {
        hide();
        return;
      }
      timer = setTimeout(() => search(q), DEBOUNCE_MS);
    });

    input.addEventListener('keydown', (e) => {
      const links = Array.from(panel.querySelectorAll('a'));
      if (e.key === 'Escape') {
        hide();
        input.blur();
      } else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (panel.hidden || !links.length) return;
        e.preventDefault();
        active = e.key === 'ArrowDown' ? (active + 1) % links.length : (active - 1 + links.length) % links.length;
        links.forEach((l, i) => {
          if (i === active) {
            l.classList.add('sn2-search-active');
            l.setAttribute('aria-selected', 'true');
            l.scrollIntoView({ block: 'nearest' });
          } else {
            l.classList.remove('sn2-search-active');
            l.removeAttribute('aria-selected');
          }
        });
      } else if (e.key === 'Enter' && active >= 0 && links[active]) {
        e.preventDefault();
        window.location.href = links[active].href;
      }
    });

    document.addEventListener(
      'click',
      (e) => {
        if (!scope.contains(e.target)) hide();
      },
      true
    );
    form.addEventListener('submit', (e) => {
      hide();
      const raw = input.value.trim();
      if (!raw) return;
      const normalized = normalizeSearchQuery(raw);
      if (normalized !== raw) {
        e.preventDefault();
        window.location.href = viewAllUrl(form, raw);
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-armada-selector="collection-search"]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
